<template>
    <div :class="pop?'video_player':'video_inline_player'">
        <div
        class="player" 
        v-if="playing && playable">
            <div class="view">
                <video 
                :autoplay="pop"
                controls
                :playsinline="pop" 
                :src="playing.link"
                id="videoplayer"
                ></video>
            </div>

            <ul v-if="!pop && playable.length>1">
                <li 
                v-for="v in playable" 
                :key="v.order" 
                @click="Change_play(v.order)" 
                :class="v.order == play_key?'':'mask'"
                >
                    <video muted playsinline :src="v.link"></video>
                </li>
            </ul>
            <button
            v-if="pop"
            @click="Close_video"
            >{{$t('home.video.button')}}</button>
        </div>
        <div class="video_loading" v-else>

        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import i18n from '../../i18n'
export default {
    name:'VideoPlayer',
    props:{
        pop:Boolean
    },
    data() {
        return {
            play_key:1
        }
    },
    computed:{
        ...mapState('frontend',[
            'Videos'
        ]),
        playable(){
            if(this.Videos && this.Videos.length>0){
                const playable = this.Videos.filter(vr=>vr.isShow)
                return playable
            }
        },
        playing(){
            if(this.playable){
                const playing = this.playable.filter(v=>v.order == this.play_key)
                return playing[0]
            }
        }
    },
    mounted() {
    //    const Video = document.getElementById('videoplayer')
    //    Video.addEventListener('loadedmetadata',()=>{
    //     //    console.log(Video.duration)
    //    })
    },
    methods: {
        Change_play(order){
            this.play_key = order
        },
        Close_video(){
            console.log('fuck')
            this.$emit('Close','')
        }
    },
    destroyed() {
        // document.getElementById('videoplayer').removeEventListener('loadedmetadata')
    },
}
</script>
<style lang="scss">
    .video_player{
        top:0;
        left:0;
        z-index: 9999999;
        display:flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width:100vw;
        height: 100vh;
        background-color: rgba($color: #000000, $alpha: 0.4);
        backdrop-filter: blur(5px);
        .player{
            display: flex;
            flex-direction: column;
            width:64%;
            .view{
                width:100%;
                video{
                    width:100%;
                }
            }
            ul{
                list-style-type: none;
                padding:0;
                li{
                    width:120px;
                    video{
                        pointer-events: none;
                        width: 100%;
                    }
                }
            }
        }
    }
</style>